<script>
import { ref } from "vue";
const value = ref();
const currentDate = ref(new Date());
export default {
  data() {
    return {
      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
      showFilterInputs: false,
      ServicSelec: ["Services", "Computer Repairs", "Plumbing"],
      klineSel: ["Name", "Jacob Kline", "William Smith"],
      CodeNum: ["Code", "1", "2"],
      StatPend: ["Status", "Paid", "Pending"],
    };
  },
  methods: {
    toggleFilterInputs() {
      this.showFilterInputs = !this.showFilterInputs;
    },
  },
};
</script>
<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
          <h5>Coupons</h5>
          <div class="d-flex align-items-center">
            <span class="fs-14 me-2">Sort</span>
            <div class="dropdown me-2">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle bg-light-300"
                data-bs-toggle="dropdown"
              >
                Newly Added
              </a>
              <div class="dropdown-menu">
                <a href="javascript:void(0);" class="dropdown-item active"
                  >Recently Added</a
                >
              </div>
            </div>
            <a
              href="javascript:void(0);"
              class="tags d-flex justify-content-center align-items-center rounded me-2"
              ><i class="ti ti-printer"></i
            ></a>
            <a
              href="javascript:void(0);"
              class="tags d-flex justify-content-center align-items-center border rounded me-2"
              id="filter_search"
              @click="toggleFilterInputs"
            >
              <i class="ti ti-sort-descending"></i>
            </a>
            <a
              href="javascript:void(0);"
              class="btn btn-dark d-flex align-items-center"
              data-bs-toggle="modal"
              data-bs-target="#add-coupons"
              ><i class="ti ti-circle-plus me-2"></i>Add Coupon</a
            >
          </div>
        </div>
        <div
          id="filter_inputs"
          v-bind:style="{ display: showFilterInputs ? 'block' : 'none' }"
        >
          <div class="row">
            <div class="col-lg-3 col-md-6 col-xl">
              <div class="mb-3">
                <div class="sel-cal Calendar-icon">
                  <span><i class="ti ti-calendar-month"></i></span>
                  <date-picker
                    v-model="startdate"
                    placeholder=""
                    class="datetimepicker form-control"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-xl">
              <div class="mb-3">
                <vue-select
                  :options="ServicSelec"
                  id="servicselc"
                  placeholder="Services"
                />
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-xl">
              <div class="mb-3">
                <vue-select :options="klineSel" id="klinesel" placeholder="Name" />
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-xl">
              <div class="mb-3">
                <vue-select :options="CodeNum" id="codenum" placeholder="Code" />
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-xl">
              <div class="mb-3">
                <vue-select :options="StatPend" id="statpend" placeholder="Status" />
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-xl-12 col-lg-12">
            <!-- Coupons List -->
            <div class="custom-datatable-filter table-responsive">
              <table class="table datatable">
                <thead class="thead-light">
                  <tr>
                    <th>Name</th>
                    <th>Code</th>
                    <th>Type</th>
                    <th>Discount</th>
                    <th>Limit</th>
                    <th>Used</th>
                    <th>Valid Date</th>
                    <th>Service Name</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>New Year</td>

                    <td>NEW2024</td>
                    <td>Percentage</td>
                    <td>5%</td>
                    <td>100</td>
                    <td>1</td>
                    <td>
                      <p class="fs-14 mb-0">Jan 01, 2023 - Jan 04, 2023</p>
                      Once per customer days
                    </td>
                    <td>Interior Designing</td>
                    <td>
                      <span
                        class="badge badge-soft-success d-inline-flex align-items-center"
                        ><i class="ti ti-circle-filled fs-5 me-1"></i>Active</span
                      >
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-coupons"
                        >
                          <i class="ti ti-edit"></i>
                        </a>
                        <a href="#" data-bs-toggle="modal" data-bs-target="#del-coupons">
                          <i class="ti ti-trash"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Black Friday</td>
                    <td>GIFTGUIDE</td>
                    <td>Percentage</td>
                    <td>5%</td>
                    <td>100</td>
                    <td>1</td>
                    <td>
                      <p class="fs-14 mb-0">20 Sep 2023 - 22 Sep 2023</p>
                      Once per customer days
                    </td>
                    <td>Car Repair</td>
                    <td>
                      <span
                        class="badge badge-soft-danger d-inline-flex align-items-center"
                        ><i class="ti ti-circle-filled fs-5 me-1"></i>Inactive</span
                      >
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-coupons"
                        >
                          <i class="ti ti-edit"></i>
                        </a>
                        <a href="#" data-bs-toggle="modal" data-bs-target="#del-coupons">
                          <i class="ti ti-trash"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Christmas</td>

                    <td>Winter2024</td>
                    <td>Fixed</td>
                    <td>$2.00</td>
                    <td>100</td>
                    <td>1</td>
                    <td>
                      <p class="fs-14 mb-0">Dec 24, 2023 - Dec 26, 2023</p>
                      Once per customer days
                    </td>
                    <td>House Cleaning</td>
                    <td>
                      <span
                        class="badge badge-soft-success d-inline-flex align-items-center"
                        ><i class="ti ti-circle-filled fs-5 me-1"></i>Active</span
                      >
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-coupons"
                        >
                          <i class="ti ti-edit"></i>
                        </a>
                        <a href="#" data-bs-toggle="modal" data-bs-target="#del-coupons">
                          <i class="ti ti-trash"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Valentines</td>

                    <td>Valentine24</td>
                    <td>Percentage</td>
                    <td>5%</td>
                    <td>100</td>
                    <td>1</td>
                    <td>
                      <p class="fs-14 mb-0">Feb 13, 2023 -Feb 15, 202</p>
                      Once per customer days
                    </td>
                    <td>Computer Services</td>
                    <td>
                      <span
                        class="badge badge-soft-danger d-inline-flex align-items-center"
                        ><i class="ti ti-circle-filled fs-5 me-1"></i>Inactive</span
                      >
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-coupons"
                        >
                          <i class="ti ti-edit"></i>
                        </a>
                        <a href="#" data-bs-toggle="modal" data-bs-target="#del-coupons">
                          <i class="ti ti-trash"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Halloween</td>

                    <td>SPOOKY15</td>
                    <td>Percentage</td>
                    <td>5%</td>
                    <td>100</td>
                    <td>1</td>
                    <td>
                      <p class="fs-14 mb-0">Nov 11, 2023 - Nov 12, 2023</p>
                      Once per customer days
                    </td>
                    <td>Car Wash</td>
                    <td>
                      <span
                        class="badge badge-soft-success d-inline-flex align-items-center"
                        ><i class="ti ti-circle-filled fs-5 me-1"></i>Active</span
                      >
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-coupons"
                        >
                          <i class="ti ti-edit"></i>
                        </a>
                        <a href="#" data-bs-toggle="modal" data-bs-target="#del-coupons">
                          <i class="ti ti-trash"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Welcome Bonus</td>

                    <td>Welcome24</td>
                    <td>Percentage</td>
                    <td>5%</td>
                    <td>100</td>
                    <td>1</td>
                    <td>
                      <p class="fs-14 mb-0">Nov 15, 2023 - Nov 17, 2023</p>
                      Once per customer days
                    </td>
                    <td>Plumbing</td>
                    <td>
                      <span
                        class="badge badge-soft-success d-inline-flex align-items-center"
                        ><i class="ti ti-circle-filled fs-5 me-1"></i>Active</span
                      >
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-coupons"
                        >
                          <i class="ti ti-edit"></i>
                        </a>
                        <a href="#" data-bs-toggle="modal" data-bs-target="#del-coupons">
                          <i class="ti ti-trash"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Thankful Deal</td>

                    <td>Thank24</td>
                    <td>Percentage</td>
                    <td>5%</td>
                    <td>100</td>
                    <td>1</td>
                    <td>
                      <p class="fs-14 mb-0">Nov 20, 2023 - Nov 30, 2023</p>
                      Once per customer days
                    </td>
                    <td>Commercial Painting</td>
                    <td>
                      <span
                        class="badge badge-soft-success d-inline-flex align-items-center"
                        ><i class="ti ti-circle-filled fs-5 me-1"></i>Active</span
                      >
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-coupons"
                        >
                          <i class="ti ti-edit"></i>
                        </a>
                        <a href="#" data-bs-toggle="modal" data-bs-target="#del-coupons">
                          <i class="ti ti-trash"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- /Coupons List -->
          </div>

          <div class="d-flex justify-content-between align-items-center">
            <div class="value d-flex align-items-center">
              <span>Show</span>
              <select>
                <option>7</option>
              </select>
              <span>entries</span>
            </div>
            <div class="d-flex align-items-center justify-content-center">
              <span class="me-2 text-gray-9">1 - 07 of 10</span>
              <nav aria-label="Page navigation">
                <ul class="paginations d-flex justify-content-center align-items-center">
                  <li class="page-item me-2">
                    <a
                      class="page-link-1 active d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >1</a
                    >
                  </li>
                  <li class="page-item me-2">
                    <a
                      class="page-link-1 d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >2</a
                    >
                  </li>
                  <li class="page-item">
                    <a
                      class="page-link-1 d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >3</a
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
    <provider-coupons-modal></provider-coupons-modal>
  </div>
</template>
